export enum NotificationTypes {
  NEW_POLL = 'NEW_POLL',
  ANSWERING_QUESTION = 'ANSWERING_QUESTION',
  ANSWERED_QUESTION = 'ANSWERED_QUESTION',
}
